import { StyleSheet } from "react-native";

/**
 * Mobile-only (iPhone) overrides for the Ticketing Portal landing screen.
 * These styles are merged on top of the base stylesheet when Platform.OS === "ios"
 * and the device width is below the iPad threshold.
 */
const mobileStyles = StyleSheet.create({
  /* ── Hero block ─────────────────────────────────────────── */
  heroBlock: {
    backgroundColor: "#034895",
    borderRadius: 16,
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 22,
    marginTop: 8,
    marginBottom: 14,
  },
  heroLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: "#8BB4E0",
    letterSpacing: 1.2,
    textTransform: "uppercase",
    marginBottom: 6,
  },
  heroGreeting: {
    fontSize: 26,
    fontWeight: "700",
    color: "#FFFFFF",
    lineHeight: 32,
  },
  heroSubtitle: {
    marginTop: 6,
    fontSize: 13,
    lineHeight: 19,
    color: "#B8C9DF",
  },
  heroChip: {
    marginTop: 14,
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    backgroundColor: "rgba(255,255,255,0.12)",
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 6,
    gap: 6,
  },
  heroChipText: {
    fontSize: 12,
    fontWeight: "600",
    color: "#D4E2F2",
  },

  /* ── Incident banner ────────────────────────────────────── */
  banner: {
    backgroundColor: "#FFF5EC",
    borderRadius: 12,
    borderLeftWidth: 4,
    borderLeftColor: "#CC6E16",
    borderWidth: 1,
    borderColor: "#FFD2BC",
    paddingVertical: 14,
    paddingHorizontal: 16,
    marginBottom: 14,
  },
  bannerTop: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },
  bannerIconWrap: {
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "#FF8C09",
    alignItems: "center",
    justifyContent: "center",
  },
  bannerIconFallback: {
    fontSize: 16,
    color: "#ffffff",
  },
  bannerBody: {
    flex: 1,
  },
  bannerTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: "#8A3E12",
    marginBottom: 2,
  },
  bannerMessage: {
    fontSize: 12,
    color: "#6B3D1A",
    lineHeight: 17,
  },
  bannerActions: {
    marginTop: 10,
    flexDirection: "row",
    gap: 8,
    marginLeft: 44
  },
  bannerBtnPrimary: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    borderWidth: 1,
    borderColor: "#CC6E16",
    borderRadius: 20,
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: "transparent",
  },
  bannerBtnPrimaryText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#CC6E16",
  },
  bannerBtnGhost: {
    borderRadius: 20,
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: "transparent",
  },
  bannerBtnGhostText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#4B4B4B",
  },

  /* ── Action tiles (compact horizontal cards) ────────────── */
  gridContainer: {
    flexDirection: "column",
    gap: 12,
    marginTop: 6,
    marginBottom: 28,
  },
  tileCard: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    paddingVertical: 16,
    paddingHorizontal: 16,
    gap: 14,
    shadowColor: "rgba(0,94,192,0.06)",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 2,
  },
  tileIconWrap: {
    width: 44,
    height: 44,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  tileBody: {
    flex: 1,
  },
  tileTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 2,
  },
  tileTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#1f2a3b",
  },
  tileBadge: {
    fontSize: 10,
    fontWeight: "700",
    color: "#ffffff",
    backgroundColor: "#156fd5",
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 2,
    overflow: "hidden",
  },
  tileBadgeAlert: {
    backgroundColor: "#c23603",
  },
  tileDescription: {
    fontSize: 12,
    lineHeight: 17,
    color: "#5f697a",
    fontWeight: "500",
  },
  tileArrowWrap: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: "#f2f4f8",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default mobileStyles;
